// 64 / (208 - 8 * 1 ) = 64 / 200 = 0.32
export const formContentRWidth1 = '32%';
// 64 / (208 - 8 * 2 ) = 64 / 192 = 1 / 3
export const formContentRWidth2 = '33.33%';
// 64 / (208 - 8 * 3 ) = 64 / 186 = 1 / 3
export const formContentRWidth3 = '34.41%';

export const formContentLWidth1 = '68%';
export const formContentLWidth2 = '66.67%';
export const formContentLWidth3 = '65.59%';
